import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function MilitaryMortgageIcon() {
  return (
    <div className={styles['container']}>
      <img src={PROMO_ICON.get('militaryMortgage')} className={styles['icon-img']} />
    </div>
  );
}
